import { useEffect, useState } from 'react';
import { Keyboard, X } from 'lucide-react';

const SHORTCUTS: { keys: string[]; desc: string }[] = [
  { keys: ['⌘', 'K'], desc: 'Open command palette' },
  { keys: ['?'],       desc: 'Toggle this shortcuts panel' },
  { keys: ['F'],       desc: 'Toggle focus mode (hide sidebars)' },
  { keys: ['G', 'D'],  desc: 'Go to Dashboard' },
  { keys: ['G', 'P'],  desc: 'Go to Players' },
  { keys: ['G', 'C'],  desc: 'Go to Live Console' },
  { keys: ['↑', '↓'],  desc: 'Navigate lists / console history' },
  { keys: ['Esc'],     desc: 'Close modal / palette' },
];

export function ShortcutsOverlay() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName;
      const typing = tag === 'INPUT' || tag === 'TEXTAREA' || (e.target as HTMLElement)?.isContentEditable;
      if (e.key === '?' && !typing && !e.metaKey && !e.ctrlKey) { e.preventDefault(); setOpen((v) => !v); }
      else if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center px-4"
      style={{ background: 'rgba(3,5,9,0.6)', backdropFilter: 'blur(4px)' }}
      onClick={() => setOpen(false)}
    >
      <div
        className="sc-glass sc-page-in w-full max-w-md rounded-2xl overflow-hidden"
        style={{ border: '1px solid var(--sc-border-mid)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b" style={{ borderColor: 'var(--sc-border)' }}>
          <div className="flex items-center gap-2 text-[9px] font-bold tracking-[0.15em] uppercase" style={{ color: 'var(--sc-muted)' }}>
            <Keyboard className="h-3.5 w-3.5" /> Keyboard Shortcuts
          </div>
          <button onClick={() => setOpen(false)} style={{ color: 'var(--sc-muted)' }}><X className="h-4 w-4" /></button>
        </div>
        <div className="p-3 flex flex-col">
          {SHORTCUTS.map((s, i) => (
            <div key={i} className="flex items-center justify-between px-2 py-2 rounded-lg" style={{ background: i % 2 ? 'transparent' : 'rgba(255,255,255,0.015)' }}>
              <span className="text-sm" style={{ color: 'var(--sc-text)' }}>{s.desc}</span>
              <span className="flex items-center gap-1">
                {s.keys.map((k) => (
                  <kbd key={k} className="min-w-[22px] text-center text-[11px] font-mono px-1.5 py-1 rounded"
                    style={{ background: 'var(--sc-bg-elevated)', border: '1px solid var(--sc-border)', color: 'var(--sc-text)' }}>
                    {k}
                  </kbd>
                ))}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
